import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Skills from './Skills';
import resumeData from '../../utils/resume-data';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import ResumePDF from '../../assets/resume/Resume.pdf';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        background: 'black',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    heading: {
        color: 'whitesmoke',
        fontSize: '2.5rem',
        textAlign: 'center',
        padding: '2rem',
        '@media (max-width:600px)': {
            fontSize: '1.8rem',
        },
    },
    skillsdiv: {
        display: 'flex',
        flexDirection: 'column',
        '@media (max-width:600px)': {
            marginLeft: '3rem',
        },
        '@media (min-width:600px)': {
            marginLeft: '5rem',
        },
    },
    grid: {
        maxWidth: '80%',
        paddingBottom: '2rem',
    },
    btn: {
        color: 'orange',
        alignSelf: 'center',
        '@media (min-width:600px)': {
            fontSize: '1rem',
        },
        '@media (min-width:1024px)': {
            fontSize: '1.2rem',
        },
    },
}));

const Resume = () => {
    const classes = useStyles();
    const allSkills = resumeData.skills

    return (
        <div className={classes.root}>
            <Typography className={classes.heading} component="h2">
                Skills
            </Typography>
            <div
                className={classes.skillsdiv}>
                {allSkills.map(skills => {
                    return (
                        <Grid className={classes.grid}
                            item
                            key={skills.type}>
                            <Skills
                                id={skills.id}
                                avatar={skills.avatar}
                                type={skills.type}
                                skills={skills.skills}
                            />
                        </Grid>
                    )
                })}
            </div>
            <Button className={classes.btn} variant="outlined" target="_blank" href={ResumePDF}>
                Download Resume <DoubleArrowIcon />
            </Button>
        </div>
    );
}

export default Resume